import { Polyline } from "../Polyline";

// LineSegment is a Polyline with exactly one segment.
class LineSegment extends Polyline {
	protected override maxSegments = 1;
}

export { LineSegment };
